module.exports = __webpack_public_path__ + "static/media/Q2_Front_Right.d1646e71.png";